import React from "react";

export default function FooterSection() {
  return (
    <footer className="footer">
      <div className="section-inner footer-inner">
        <div>
          <h3>Sparkdenz</h3>
          <p>Designing growth for brands that move fast.</p>
        </div>
        <div className="footer-links">
          <a href="#services">Services</a>
          <a href="#work">Work</a>
          <a href="#about">About</a>
          <a href="#contact">Contact</a>
        </div>
        <div className="footer-social">
          <a
            href="https://www.linkedin.com/company/sparkdenz/"
            aria-label="LinkedIn"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/linkedin.png" alt="Sparkdenz LinkedIn profile" />
          </a>
          <a
            href="https://www.instagram.com/sparkdenz/"
            aria-label="Instagram"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/insta.png" alt="Sparkdenz Instagram profile" />
          </a>
          <a
            href="https://www.threads.com/@sparkdenz"
            aria-label="Threads"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/thread.png" alt="Sparkdenz Threads profile" />
          </a>
        </div>
        <div className="footer-meta">
          <span>Â© 2026 Sparkdenz Studio</span>
          <span>Strategy Â· Creative Â· Performance</span>
        </div>
      </div>
    </footer>
  );
}
